import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Layout from "../../components/layouts/Layout";
import InfoCard from "../../components/dashboard/InfoCard";
import {
  chartOptions,
  extractChartData,
  extractUserData,
} from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardData } from "../../store/DashboardSlice";

function getUser() {
  let user = localStorage.getItem("user");

  if (user) {
    user = JSON.parse(user);
  } else {
    user = null;
  }

  return user;
}
const currYear = new Date().getFullYear();

const Home = () => {
  const [user, setUser] = useState(getUser());
  const dispatch = useDispatch();

  const dashboardData = useSelector((state) => state.dashboard);

  const [series, setSeries] = useState([]);
  const [quickStats, setQuickStats] = useState([]);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, []);

  useEffect(() => {
    const organizationData = extractChartData(
      dashboardData.organizations,
      currYear
    );
    const applicationData = extractChartData(
      dashboardData.applications,
      currYear
    );

    const subscriptionData = extractChartData(
      dashboardData.subscriptions,
      currYear
    );

    const usersData = extractChartData(dashboardData.users, currYear);
    const userData = extractUserData(dashboardData.users);
    console.log(userData);
    setQuickStats([
      {
        name: "Organizations",
        currYear: organizationData.currYearTotal,
        currMonth: organizationData.currMonthTotal,
      },
      {
        name: "Users",
        currYear: usersData.currYearTotal,
        currMonth: usersData.currMonthTotal,
      },
      {
        name: "Applications",
        currYear: applicationData.currYearTotal,
        currMonth: applicationData.currMonthTotal,
      },
    ]);
    setSeries([
      {
        graphName: "Organisations",
        graphSeries: [{ data: organizationData.counts, name: "value" }],
        graphYears: organizationData.years,
        selectedYear: currYear,
        graphType: "bar",
        options: {},
      },
      {
        graphName: "Applications",
        graphSeries: [{ data: applicationData.counts, name: "value" }],
        graphYears: applicationData.years,
        selectedYear: currYear,
        graphType: "bar",
        options: {},
      },
      // {
      //   graphName: "Users",
      //   graphSeries: userData,
      //   graphType: "pie",
      //   options: { labels: ["Primary Users", "Secondary Users"] },
      //   graphYears: applicationData.years,
      //   selectedYear: currYear,
      // },
      // {
      //   graphName: "Subscription",
      //   graphSeries: subscriptionData,
      //   graphType: "line",
      //   graphSeries: [{ data: subscriptionData.counts, name: "value" }],
      //   graphYears: subscriptionData.years,
      //   selectedYear: currYear,
      //   options: {},
      // },
    ]);
  }, [dashboardData]);

  const onYearChangeHandler = (year, index) => {
    const newSeries = [...series];
    newSeries[index].selectedYear = year;
    newSeries[index].graphSeries = [
      {
        data: extractChartData(dashboardData.organizations, Number(year))
          .counts,
        name: "value",
      },
    ];
    setSeries(newSeries);
  };

  return (
    <Layout>
      <div className="container-fluid">
        <div className="pages px-3 pb-3">
          <div className="home">
            <div className="row">
              <h2 className="my-4">
                Hi <b className="text-primary">{user ? user.name : ""}</b>,
              </h2>

              {/* Initial top card containers */}
              <div className="row">
                {quickStats.map((item, index) => (
                  <InfoCard key={index} {...item} />
                ))}
              </div>

              <div className="row gy-3">
                {series.map((item, index) => (
                  <div key={index} className="col-md-6 d-flex align-items-strech">
                    <div className="card w-100">
                      <div className="card-body">
                        <div className="d-sm-flex d-block align-items-center justify-content-between mb-9">
                          <div className="mb-3 mb-sm-0">
                            <h5 className="card-title fw-semibold">
                              {item.graphName} Overview
                            </h5>
                          </div>
                          {item.graphYears && (
                            <div>
                              <select
                                className="form-select"
                                defaultValue={item.selectedYear}
                                onChange={(e) =>
                                  onYearChangeHandler(e.target.value, index)
                                }
                              >
                                {item.graphYears.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                        <div className="bg-white">
                          <Chart
                            options={{ ...chartOptions, ...item.options }}
                            series={item.graphSeries}
                            type={item.graphType}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

    </Layout>
  );
};

export default Home;
